// 由 EB view/admin/src/router/modules/safe.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const safeRouter: RouteRecordRaw =
  {
    path: `${roterPre}/safe`,
    name: 'Safe',
    meta: {
      icon: '',
      title: '维护'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'pageLinks',
        name: 'PageLinks',
        meta: {
          title: '页面链接'
        },
        component: () => import('@/views/safe/pageLinks/index.vue')
      },
      {
        path: 'pcLinks',
        name: 'PcLinks',
        meta: {
          title: 'PC商城页面链接'
        },
        component: () => import('@/views/safe/pcLinks/index.vue')
      }
    ]
  }

export default safeRouter;
